<template>
  <div class="contact section flex-col items-center">
    <h1 class="contact-title">CONTACT</h1>
    <div
      class="contact-info"
      v-html="data.results && data.results[0] && data.results[0].content"
    ></div>
    <div class="map">
      <iframe
        src="map.html"
        frameborder="0"
        width="1049"
        height="655"
        style="border: 0"
        loading="lazy"
        allowfullscreen
      ></iframe>
    </div>
    <!-- <div class="contact-info">
      <p style="margin-bottom: 34px; color: #535353">
        International Centre For Engineering Education under the auspices of
        UNESCO(ICEE)
      </p>
      <p>
        Address：4F, Wennan Building, Tsinghua University, Haidian District,
        Beijing, P.R.China, 100084
      </p>
      <p>Tel： 86(10)-62791751</p>
      <p>
        E-mail：
        <a href="mailto:icee@tsinghua.edu.cn" class="mail"
          >icee@tsinghua.edu.cn</a
        >
      </p>
    </div> -->
    <!-- https://console.cloud.google.com/projectselector2/google/maps-apis/credentials?hl=zh-CN&_ga=2.260522889.582693530.1637668570-279052503.1637668570 -->
    <!-- <iframe
                width="600"
                height="450"
                style="border:0"
                loading="lazy"
                allowfullscreen
                src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJjzweph9U8DURyeLg4P5QWtk&key=AIzaSyDYrGx5AZRSwokaXFfSSq9_OpPCGknKI2I"
        ></iframe>-->
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import homePartnerVue from "../home/components/home-partner.vue";
import { useFetchItem } from "../../hooks/fetch-item";
import { api } from "../../utils/apis";
export default defineComponent({
  name: "Contact",
  components: {
    homePartnerVue,
  },
  setup() {
    const { data } = useFetchItem({
      api: api.contact,
    });
    return {
      data,
    };
  },
});
</script>
<style lang="scss" scoped>
.contact {
  p {
    margin-bottom: 0;
  }
  .contact-info {
    width: 720px;
    font-size: 16px;
    font-weight: 400;
    color: #5b5b5b;
    line-height: 30px;
  }
  .contact-title {
    text-align: center;
    height: 30px;
    font-size: 22px;
    font-weight: 600;
    color: #231916;
    line-height: 30px;
    margin: 60px;
  }
  .map {
    width: 1049px;
    height: 655px;
    background: #d8d8d8;
    border: 1px solid #979797;
    margin: 40px 0 70px;
    box-sizing: content-box;
  }
  .mail {
    color: #5b5b5b;
    text-decoration: underline;
  }
}
</style>
